import React, {Component} from 'react';
import '../../style.css';
import {Button, Card, Dropdown, Form, Menu, message, Modal, PageHeader, Space, Table, Tag} from "antd";
import {fetchPost, fetchPostFile} from "../../static/util/fetch";
import { FolderViewOutlined } from "@ant-design/icons";
import FileViewer from 'react-file-viewer';
const { Column } = Table;

class HighTechUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyName:this.props.companyName,
            IPAuthorized:[],
            otherId:0,
            patentName:'',
            companyId:this.props.companyId,
            preview_visible:false,
            fileChoose:'请选择文件类型',
            //查新报告//检测报告//软件著作权证书//实用新型证书//发明专利证书//销售合同//销售发票//用户报告//产品照片
            checkStatus1:false,
            checkStatus2:false,
            checkStatus4:false,
            checkStatus5:false,
            checkStatus6:false,
            checkStatus7:false,
            loading1:false,
            loading2:false,
            loading4:false,
            loading5:false,
            loading6:false,
            loading7:false,
        }
        this.hideModal = this.hideModal.bind(this);
    }
    componentDidMount() {
        function repetition(arr) { // 去除product相同留下id大的
            arr.forEach(i => {
                arr.forEach(j => {
                    if (i.product === j.product) {
                        if (i.id > j.id) {
                            arr = arr.filter(k => {
                                if (k.product === j.product && k.id === j.id) {
                                    return false;
                                }
                                return true;
                            });
                        }
                    }
                });
            });
            return arr;
        }
        fetchPost(global.constants.getPatentTransferSummaryGetD,{companyId: this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            IPAuthorized:repetition(res.data),
                        }))
                    }
                }
            )
    }
    hideModal(){
        this.setState(()=>({
            preview_visible:false,
        }))
    }
    handlePreviewClick(e){
        const value = e.id;
        this.setState(()=>({
            preview_visible:true,
            otherId: value,
            loading1:false,
            loading2:false,
            loading4:false,
            loading5:false,
            loading6:false,
            loading7:false,
        }))
        let params1 = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:value,
            remark:'查新报告',
            url:'',
        }
        fetchPost(global.constants.checkFile, params1)
            .then(
                res => {
                    if(res.code === 200){
                        this.setState(()=>({
                            checkStatus1:true
                        }))
                    }
                    else{
                        this.setState(()=>({
                            checkStatus1:false,
                        }))
                    }
                })
        let params2 = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:value,
            remark:'检测报告',
            url:'',
        }
        fetchPost(global.constants.checkFile, params2)
            .then(
                res => {
                        if(res.code === 200){
                            this.setState(()=>({
                                checkStatus2:true
                            }))
                        }
                        else{
                            this.setState(()=>({
                                checkStatus2:false,
                            }))
                        }}
                )
        let params4 = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:value,
            remark:'销售合同',
            url:'',
        }
        fetchPost(global.constants.checkFile, params4)
            .then(
                res => {
                    if(res.code === 200){
                        this.setState(()=>({
                            checkStatus4:true
                        }))
                    }
                    else{
                        this.setState(()=>({
                            checkStatus4:false,
                        }))
                    }
                })
        let params5 = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:value,
            remark:'销售发票',
            url:'',
        }
        fetchPost(global.constants.checkFile, params5)
            .then(
                res => {
                    if(res.code === 200){
                            this.setState(()=>({
                                checkStatus5:true
                            }))
                        }
                        else{
                            this.setState(()=>({
                                checkStatus5:false,
                            }))
                        }
                })
        let params6 = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:value,
            remark:'用户报告',
            url:'',
        }
        fetchPost(global.constants.checkFile, params6)
            .then(
                res => {
                    if(res.code === 200){
                            this.setState(()=>({
                                checkStatus6:true
                            }))
                        }
                        else{
                            this.setState(()=>({
                                checkStatus6:false,
                            }))
                        }
                })
        let params7 = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:value,
            remark:'产品照片',
            url:'',
        }
        fetchPost(global.constants.checkFile, params7)
            .then(
                res => {
                    if(res.code === 200){
                        this.setState(()=>({
                            checkStatus7:true
                        }))
                    }
                    else{
                        this.setState(()=>({
                            checkStatus7:false,
                        }))
                    }
                })
    }
    preview(){
        if(this.state.fileChoose === "查新报告"){
            if (this.state.checkStatus1) {
                let params = {
                    companyId:this.state.companyId,
                    projectId:0,
                    productId:0,
                    patentId:0,
                    otherId:this.state.otherId,
                    remark:'查新报告',
                    url: '',
                    fileName: ''
                }
                fetchPostFile(global.constants.previewFile,params)
                    .then(
                        res=>{
                            res.blob().then(
                                blob=> {
                                    let blobUrl = window.URL.createObjectURL(blob);
                                    this.setState(()=>({
                                        fileStream1:blobUrl,
                                        loading1: true
                                    }))
                                })
                        }
                    )
            }else{message.info("该文件未上传！").then()}
        }
        if(this.state.fileChoose === "检测报告") {
            if (this.state.checkStatus2) {
                let params = {
                    companyId:this.state.companyId,
                    projectId:0,
                    productId:0,
                    patentId:0,
                    otherId:this.state.otherId,
                    remark:'检测报告',
                    url: '',
                    fileName: ''
                }
                fetchPostFile(global.constants.previewFile,params)
                    .then(
                        res=>{
                            res.blob().then(
                                blob=> {
                                    let blobUrl = window.URL.createObjectURL(blob);
                                    this.setState(()=>({
                                        fileStream2:blobUrl,
                                        loading2: true
                                    }))
                                })
                        }
                    )
            }else{message.info("该文件未上传！").then()}
        }
        if(this.state.fileChoose === "销售合同") {
            if (this.state.checkStatus4) {
                let params = {
                    companyId:this.state.companyId,
                    projectId:0,
                    productId:0,
                    patentId:0,
                    otherId:this.state.otherId,
                    remark:'销售合同',
                    url: '',
                    fileName: ''
                }
                fetchPostFile(global.constants.previewFile,params)
                    .then(
                        res=>{
                            res.blob().then(
                                blob=> {
                                    let blobUrl = window.URL.createObjectURL(blob);
                                    this.setState(()=>({
                                        fileStream4:blobUrl,
                                        loading4: true
                                    }))
                                })
                        }
                    )
            }else{message.info("该文件未上传！").then()}
        }
        if(this.state.fileChoose === "销售发票") {
            if (this.state.checkStatus5) {
                let params = {
                    companyId:this.state.companyId,
                    projectId:0,
                    productId:0,
                    patentId:0,
                    otherId:this.state.otherId,
                    remark:'销售发票',
                    url: '',
                    fileName: ''
                }
                fetchPostFile(global.constants.previewFile,params)
                    .then(
                        res=>{
                            res.blob().then(
                                blob=> {
                                    let blobUrl = window.URL.createObjectURL(blob);
                                    this.setState(()=>({
                                        fileStream5:blobUrl,
                                        loading5: true
                                    }))
                                })
                        }
                    )
            }else{message.info("该文件未上传！").then()}
        }
        if(this.state.fileChoose === "用户报告") {
            if (this.state.checkStatus6) {
                let params = {
                    companyId:this.state.companyId,
                    projectId:0,
                    productId:0,
                    patentId:0,
                    otherId:this.state.otherId,
                    remark:'用户报告',
                    url: '',
                    fileName: ''
                }
                fetchPostFile(global.constants.previewFile,params)
                    .then(
                        res=>{
                            res.blob().then(
                                blob=> {
                                    let blobUrl = window.URL.createObjectURL(blob);
                                    this.setState(()=>({
                                        fileStream6:blobUrl,
                                        loading6: true
                                    }))
                                })
                        }
                    )
            }else{message.info("该文件未上传！").then()}
        }
        if(this.state.fileChoose === "产品照片") {
            if (this.state.checkStatus7) {
                let params = {
                    companyId:this.state.companyId,
                    projectId:0,
                    productId:0,
                    patentId:0,
                    otherId:this.state.otherId,
                    remark:'产品照片',
                    url: '',
                    fileName: ''
                }
                fetchPostFile(global.constants.previewFile,params)
                    .then(
                        res=>{
                            res.blob().then(
                                blob=> {
                                    let blobUrl = window.URL.createObjectURL(blob);
                                    this.setState(()=>({
                                        fileStream7:blobUrl,
                                        loading7: true
                                    }))
                                })
                        }
                    )
            }else{message.info("该文件未上传！").then()}
        }
    }
    fileChange(e){
        this.setState(()=>({
            fileChoose:e,
            loading1:false,
            loading2:false,
            loading4:false,
            loading5:false,
            loading6:false,
            loading7:false,
        }))
    }
    render() {
        const file_menu = (
            <Menu>
                <Menu.Item onClick={this.fileChange.bind(this,'查新报告')}>
                    查新报告（选填）
                    {this.state.checkStatus1 === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                </Menu.Item>
                <Menu.Item onClick={this.fileChange.bind(this,'检测报告')}>
                    检测报告（选填）
                    {this.state.checkStatus2 === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                </Menu.Item>
                <Menu.Item onClick={this.fileChange.bind(this,'销售合同')}>
                    销售合同
                    {this.state.checkStatus4 === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                </Menu.Item>
                <Menu.Item onClick={this.fileChange.bind(this,'销售发票')}>
                    销售发票
                    {this.state.checkStatus5 === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                </Menu.Item>
                <Menu.Item onClick={this.fileChange.bind(this,'用户报告')}>
                    用户报告（选填）
                    {this.state.checkStatus6 === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                </Menu.Item>
                <Menu.Item onClick={this.fileChange.bind(this,'产品照片')}>
                    产品照片（选填）
                    {this.state.checkStatus7 === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                </Menu.Item>
            </Menu>
        )
        return (
            <div>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="显示成果转化的证明材料"
                        subTitle="江苏"
                    >
                    </PageHeader>
                </div>
                <Space direction="vertical" className="content-style" >
                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                        <Table dataSource={this.state.IPAuthorized}>
                            <Column align="center" title={<p className="list-column-style">序号</p>} width="80" render={(text,record,index)=>`${index+1}`}/>
                            <Column align="center" title={<p className="list-column-style">产品名称</p>} dataIndex="product" key="product" />
                            <Column
                                align="center"
                                title={<p className="list-column-style">操作</p>}
                                key="action"
                                render={(text, record) => (
                                    <Space size="middle">
                                        <Button
                                            type="primary"
                                            icon={<FolderViewOutlined />}
                                            onClick={this.handlePreviewClick.bind(this,record)}
                                        >预览</Button>
                                    </Space>
                                )}
                            />
                        </Table>
                    </Card>
                </Space>
                <Modal
                    visible={this.state.preview_visible}
                    title={'查看附件'}
                    onCancel={this.hideModal}
                    width={'60%'}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.hideModal}>
                            完成
                        </Button>,
                    ]}
                >
                    <div>
                        <Dropdown overlay={file_menu} placement="bottomCenter" arrow trigger='click'>
                            <Button type="primary" style={{marginRight:10}}>{this.state.fileChoose}</Button>
                        </Dropdown>
                        <Button  type={"primary"} onClick={this.preview.bind(this)}>预览</Button>
                        <Form>
                            <Form.Item name="preview_paper">
                                {
                                    this.state.loading1 === true &&
                                    this.state.fileChoose === '查新报告'&&
                                    <FileViewer fileType='pdf'
                                                filePath={this.state.fileStream1}
                                                onError={this.onError}
                                    />
                                }
                                {
                                    this.state.loading2 === true &&
                                    this.state.fileChoose === '检测报告'&&
                                    <FileViewer fileType='pdf'
                                                filePath={this.state.fileStream2}
                                                onError={this.onError}
                                    />
                                }
                                {
                                    this.state.loading4 === true &&
                                    this.state.fileChoose === '销售合同'&&
                                    <FileViewer fileType='pdf'
                                                filePath={this.state.fileStream4}
                                                onError={this.onError}
                                    />
                                }
                                {
                                    this.state.loading5 === true &&
                                    this.state.fileChoose === '销售发票'&&
                                    <FileViewer fileType='pdf'
                                                filePath={this.state.fileStream5}
                                                onError={this.onError}
                                    />
                                }
                                {
                                    this.state.loading6 === true &&
                                    this.state.fileChoose === '用户报告'&&
                                    <FileViewer fileType='pdf'
                                                filePath={this.state.fileStream6}
                                                onError={this.onError}
                                    />
                                }
                                {
                                    this.state.loading7 === true &&
                                    this.state.fileChoose === '产品照片'&&
                                    <FileViewer fileType='pdf'
                                                filePath={this.state.fileStream7}
                                                onError={this.onError}
                                    />
                                }
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default HighTechUpload;